import { removeToken } from '@store/features/auth/token/slice';
import { removeUserProfile } from '@store/features/auth/user/slice';
import store from '@store/store';

const handleLogout = () => {
  store.dispatch(removeToken());
  store.dispatch(removeUserProfile());
  if (process.env.REACT_APP_LOGOUT_URL) window.location.href = process.env.REACT_APP_LOGOUT_URL;
};

export default handleLogout;
